export default __webpack_public_path__ + "static/media/background2.c446d0e6.png";